










import Vue from 'vue';
import { mapState } from 'vuex';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { ProductInterface } from '@/types/product';

@Component({})
export default class Products extends Vue {
  @Getter('allProducts', { namespace: 'products' })
  protected products!: ProductInterface[];

  protected created() {
    if (!this.$store.state.products.isDataLoaded) {
      this.$store.dispatch('products/loadProducts')
        .then()
        .catch(() => { /* Error is caught and handled in the store. Add catch here to prevent errors in console */ });
    }
  }
}
